import moment from 'moment';
import {
  AllocationForProject,
  OverAllocationApi,
  ResourceType,
} from 'api/resource-management/types';
import { INVALID_ROLE_ID } from 'components/organisms/resource-management/utils/common';
import {
  resourceIdForTeamAsLeaf,
  resourceIdForUserAsLeaf,
} from 'components/organisms/resource-management/utils/id';
import { numberOfWorkingDaysBetweenDates } from 'components/organisms/timesheets/common/utils';
import { AllocationEvent, SchedulerEventType } from '../../event-types';
import { ExcludeNonWorkingDaysParam } from '../../types';
import { normalizeAllocationPreviewHtml } from '../preview-text';
import { getSchedulerEventProps, getSchedulerEventsClass } from './common';

export const allocationForProjectAsEvent = (
  allocation: AllocationForProject,
  projectId: number,
  overAllocations: OverAllocationApi[],
  exclusionParam: ExcludeNonWorkingDaysParam,
  softAllocationsEnabled?: boolean,
): AllocationEvent => {
  const totalMinutes =
    numberOfWorkingDaysBetweenDates(
      moment(allocation.startDate).startOf('day'),
      moment(allocation.endDate).endOf('day'),
      exclusionParam.workingDaysConfig,
      allocation.includeSaturday ?? false,
      allocation.includeSunday ?? false,
    ) * allocation.minutes;

  return {
    type: SchedulerEventType.Allocation,
    id: allocation.id,
    ...(allocation.type === ResourceType.User
      ? {
          resourceId: resourceIdForUserAsLeaf({
            projectId,
            userId: allocation.user.userId,
            roleId: allocation.role?.roleId,
            referenceTeamId: allocation.referenceTeam?.teamId,
          }),
          userId: allocation.user.userId,
          roleId: allocation.role?.roleId,
          referenceTeamId: allocation.referenceTeam?.teamId,
        }
      : {
          resourceId: resourceIdForTeamAsLeaf(
            projectId,
            allocation.team.teamId,
          ),
          teamId: allocation.team.teamId,
          roleId: allocation.team.roleId ?? INVALID_ROLE_ID,
        }),
    startDate: moment(allocation.startDate).startOf('day').toDate(),
    endDate: moment(allocation.endDate).endOf('day').toDate(),
    totalMinutes,
    minutes: totalMinutes === 0 ? 0 : allocation.minutes,
    projectPhase: allocation.projectPhase,
    billable: allocation.billable,
    projectId,
    overAllocations,
    // Moving this to the resource allocation summary event
    // overAllocationsForUI: overAllocationsAsUIFormat(overAllocations),
    overAllocationsForUI: [],
    medium: allocation.medium,
    includeSaturday: allocation.includeSaturday ?? false,
    includeSunday: allocation.includeSunday ?? false,
    previewText: normalizeAllocationPreviewHtml(allocation.previewText),
    ...getSchedulerEventProps(SchedulerEventType.Allocation, {
      cls: getSchedulerEventsClass(
        SchedulerEventType.Allocation,
        `${softAllocationsEnabled ? allocation.medium : ''}`.toLowerCase(),
      ),
    }),
  };
};
